import * as React from 'react';
const Eye = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-eye", ...props },
    React.createElement("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "3" })));
export default Eye;
//# sourceMappingURL=Eye.js.map